/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Event_TextInputs */



/**
* | output |
* | --- |
* | "Bold event text" |
*
* @param {Bold_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const bold_event_text = /** @type {((inputs?: Bold_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte d'événement en gras")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fettgedruckter Ereignistext")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo dell'evento in grassetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Жирным шрифтом выделен текст события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto de evento en negrita")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粗体事件文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("太字のイベントテキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बोल्ड इवेंट टेक्स्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto do evento em negrito")
	return /** @type {LocalizedString} */ ("Bold event text")
});